<template>
  <div class="popover-content">
    <asModalDialog ref="emailSentModal" ok-button-text="Sulje"
      :show-cancel=false>
      <p>
        Salasanan nollaamiseksi on lähetetty sähköpostiviesti
      </p>
    </asModalDialog>
    <div class="product-search" v-if="!recoverPassword">
      <input
        v-model="email"
        type="text"
        placeholder="Sähköpostiosoite"
        class="input pm-input mb-5"
      />
      <input
        v-model="password"
        type="password"
        placeholder="Salasana"
        class="input pm-input mb-5"
      />
      <div class="buttons-row">
        <button class="pyroll-button purple-bg font-white" @click="login">Kirjaudu sisään</button>
        <button class="pyroll-button purple-bg font-white" @click="this.$router.push({ name: 'RegisterPage' })">Rekisteröidy</button>
      </div>
      <div v-if="errors.length" class="notification is-danger mb-4 mt-4">
        <ul>
          <li v-for="(error, index) in errors" :key="index">
            {{ error }}
          </li>
        </ul>
      </div>
      <p v-if="loginError" class="has-text-danger has-text-centered mb-4 mt-4 font-12">
        {{ loginError }}
      </p>
      <p v-if="loginError" class="has-text-danger has-text-centered mb-4 mt-4 font-12">
        Unohditko salasanasi? paina <a href="#" @click.prevent.stop="recoverPasswordClick">tästä</a> palauttaaksesi sen.
      </p>
    </div>
    <div id="reset-password-div" v-else>
      <input
        v-model="recoverEmail"
        type="text"
        placeholder="Sähköpostiosoite"
        class="input pm-input mb-5"
        v-if="!emailSent"
      />
      <div class="buttons-row" v-if="!emailSent">
        <button class="pyroll-button purple-bg font-white" @click.prevent.stop="sendEmail">Lähetä sähköposti</button>
      </div>
    </div>
  </div>
</template>

<script>
import asModalDialogMixin from "@/helpers/modalMixing"
import asModalDialog from "@/helpers/asModalDialog"
import {mapActions} from "vuex";

export default {
  name: 'loginModal',
  mixins: [
    asModalDialogMixin
  ],
  data() {
    return {
      email: '',
      recoverEmail: '',
      password: '',
      loginError: null,
      recoverPassword: false,
      emailSent: false,
      errors: []
    }
  },
  components: {
    asModalDialog
  },
  methods: {
    ...mapActions([
      'getAuthenticate',
      'postResetPassword'
    ]),
    login() {
      this.errors = []

      if (!this.email) {
        this.errors.push('Sähköpostiosoite pakollinen.')
      }

      if (!this.password) {
        this.errors.push('Salasana pakollinen.')
      }

      if (this.errors.length) {
        return
      }

      this.loginError = null
      this.getAuthenticate({
        email: this.email,
        password: this.password,
        force: true
      }).then(() => {
        this.$router.push({ name: 'Designs' })
      })
      if (this.$store.state.getAuthenticateStatusCode==403) {
        this.loginError = 'Sähköposti tai salasana on virheellinen'
      }
    },
    recoverPasswordClick() {
      this.recoverPassword = true
    },
    sendEmail() {
      this.emailSent = true
      this.$refs.emailSentModal.showModal().then(() => {
        this.postResetPassword({email: this.recoverEmail})
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.popover-content {
  z-index: 10;
  position: absolute;
  background-color: white;
  width: 400px;
  right: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 50px;
  padding-left: 50px;
  border: 1px solid black;
  top: 80px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;

  @media (max-width: 768px) {
    width: 100%;
    right: 0;
  }
  button {
    width: 150px;
  }
}

ul.product-list {
  li:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.buttons-row {
  display: flex;
  gap: 12px;
}

</style>
